import { render, staticRenderFns } from "./OrderDeliver.vue?vue&type=template&id=3b4f8274&scoped=true"
import script from "./OrderDeliver.vue?vue&type=script&lang=js"
export * from "./OrderDeliver.vue?vue&type=script&lang=js"
import style0 from "./OrderDeliver.vue?vue&type=style&index=0&id=3b4f8274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f8274",
  null
  
)

export default component.exports